import Vue from "vue";
import Snackbar from "../components/lib/Snackbar.vue";
import Loading from "../components/lib/loading-dot.vue";
import SvgIcon from "../components/lib/SvgIcon.vue";
import PrimaryBtn from "../components/elements/PrimaryBtn.vue";
import OutlineBtn from "../components/elements/OutlineBtn.vue";
import BaseCard from "../components/elements/BaseCard.vue";
import BaseCardAction from "../components/elements/BaseCardAction.vue";

Vue.component("snackbar", Snackbar);
Vue.component("loading", Loading);
Vue.component("svg-icon", SvgIcon);
Vue.component("primary-btn", PrimaryBtn);
Vue.component("outline-btn", OutlineBtn);
Vue.component("base-card", BaseCard);
Vue.component("base-card-action", BaseCardAction);
